"use client";

import { c as _c } from "react/compiler-runtime";
import { type FragmentOfShopifyStorefront, readFragmentShopifyStorefront } from "@repo/graphql-shopify-storefront";
import type { Usable } from "react";
import type { ResolvedIntlConfig } from "react-intl";
import { env } from "#/utilities/env";
import { cn } from "@repo/lib";
import { useParams } from "next/navigation";
import { useEffect, useState } from "react";
import { RefineBy } from "./refine-by";
import { RefineByFilterByPathItem } from "#/components/molecules/search-refinements/refine-by-filter-by-path-item";
import { useGetIntl } from "@repo/i18n/intl/client";
import { Collection_Fragment } from "#/graphql/shopify-storefront/fragments";
export function CollectionsNav(t0) {
  const $ = _c(23);
  const {
    className,
    collectionsMasked,
    dictionaryPromise,
    lang,
    title
  } = t0;
  let t1;
  if ($[0] !== dictionaryPromise || $[1] !== lang) {
    t1 = {
      dictionaryPromise,
      lang
    };
    $[0] = dictionaryPromise;
    $[1] = lang;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const intl = useGetIntl(t1);
  let t2;
  if ($[3] !== collectionsMasked) {
    t2 = collectionsMasked.map(_temp).filter(_temp2);
    $[3] = collectionsMasked;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const collections = t2;
  const params = useParams();
  const [active, setActive] = useState("All");
  let t3;
  if ($[5] !== collections || $[6] !== params?.collection) {
    t3 = () => {
      collections.forEach(collection_0 => {
        if (params?.collection === collection_0.handle) {
          setActive(collection_0.title);
        }
      });
    };
    $[5] = collections;
    $[6] = params?.collection;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = params?.collection;
  let t5;
  if ($[8] !== collections || $[9] !== t4) {
    t5 = [t4, collections];
    $[8] = collections;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  useEffect(t3, t5);
  let t6;
  if ($[11] !== className) {
    t6 = cn({
      hidden: env.NEXT_PUBLIC_FEATURE_FLAG_SEARCH_COLLECTIONS_ENABLE === false
    }, className);
    $[11] = className;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== intl || $[14] !== title) {
    t7 = title ?? intl.formatMessage({
      defaultMessage: "Collections",
      description: "Title for collections navigation",
      id: "ag1T/y"
    });
    $[13] = intl;
    $[14] = title;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== collectionsMasked) {
    t8 = collectionsMasked.map(_temp3);
    $[16] = collectionsMasked;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== active || $[19] !== t6 || $[20] !== t7 || $[21] !== t8) {
    t9 = <RefineBy active={active} className={t6} title={t7}>{t8}</RefineBy>;
    $[18] = active;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}
function _temp3(collectionMasked_0, index) {
  return <RefineByFilterByPathItem key={index} collectionMasked={collectionMasked_0} />;
}
function _temp2(collection) {
  return !collection.handle.startsWith("hidden");
}
function _temp(collectionMasked) {
  return readFragmentShopifyStorefront(Collection_Fragment, collectionMasked);
}